import { DealCatalog } from '@/components/dealCatalog-page';
import useRefresh from '../../hooks/use-refresh';

const DealCatalogPage = () => {
  useRefresh();
  return <DealCatalog />;
};

export default DealCatalogPage;
